var _defs, _ellipse;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSliderThumbmin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 57.557,
    width: 22.183,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    r: 8.859,
    fy: 95.013,
    fx: 300,
    cy: 95.013,
    cx: 300,
    gradientTransform: "matrix(1.80376 0 0 3.88594 -241.13 -274.202)",
    gradientUnits: "userSpaceOnUse",
    id: "prefix__d",
    xlinkHref: "#prefix__c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5cb6b"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    ry: 28.778,
    rx: 11.091,
    cy: 95.013,
    cx: 300,
    fill: "url(#prefix__d)",
    paintOrder: "stroke fill markers",
    transform: "translate(-288.909 -66.235)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderThumbmin);
export default __webpack_public_path__ + "static/media/SliderThumb.min.8f84b601cd0142636b03be2cc1c1aa9c.svg";
export { ForwardRef as ReactComponent };